import { render } from "./questionSix.vue?vue&type=template&id=bc4018c8"
import script from "./questionSix.vue?vue&type=script&lang=ts"
export * from "./questionSix.vue?vue&type=script&lang=ts"

import "./questionSix.vue?vue&type=style&index=0&id=bc4018c8&lang=css"
script.render = render

export default script